export enum VendorCustomerOperationTypeEnum {
  IndividualEntity  = 0,
  LimitedLiabilityCompany  = 1,
  Individual = 2,
  Jointliabilitycommunity = 3,
  Jointstockcompany = 4,
  LimitedPartnership= 5,
  Nonprofitlegalentity= 6,
  Branchofforeignenterprise= 7,
  Foreignenterprise = 8,
  Legalentityofpubliclaw = 9,
  Stateauthority= 10,
  Nonresidentindividual = 11,
  Partnership= 12,
  Branchofaforeignnoncommerciallegalentity= 13,
  BudgetaryOrganization= 14,
  Politicalorganization= 15,
}
